export const AVATAR_PARAMS_CONFIG = {
  ethnicity: { type: 'string', defaultValue: 'European' },
  size: { type: 'string', defaultValue: 'L' },
};

export const AVATAR_ETHNICITY_LIST = [
  'European',
  'African',
  'Latino',
  'East Asian',
  'South Asian',
  'Middle Eastern',
];

export const AVATAR_ETHNICITY_NAME_MATCHING = {
  European: 'White',
  African: 'Black',
  Latino: 'Latino',
  'East Asian': 'East Asian',
  'South Asian': 'South Asian',
  'Middle Eastern': 'Middle Eastern',
};

export const AVATAR_SIZE_LIST = ['XS', 'S', 'M', 'L', 'XL'];
